<template>
  <div v-if="viewTypeTab === 'desktopViewTab'">
    <v-expansion-panels v-model="getPromoPanel" multiple focusable>
      <v-expansion-panel>
        <v-expansion-panel-title>Message</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionActionsTitleMessage :model="model" :actions="actions" :app="app" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>Background</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <div>
            <v-text-field
              v-model.trim="actions.rf_settings_bg_image_color"
              variant="outlined"
              density="compact"
              persistentPlaceholder
              hideDetails
              label="Background Color"
              name="bg-image-color"
              placeholder="e.g.: #336699"
              style="padding: 5px 0 2px"
              @blur="
                actions.rf_settings_bg_image_color = extendHex(actions.rf_settings_bg_image_color)
              "
            ></v-text-field>
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>User Interaction</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <v-radio-group
            v-model="actions.rf_settings_tile_interaction"
            inline
            hideDetails
            class="inline-interactions-opt"
          >
            <v-radio value="container" label="Block" />
            <v-radio value="none" label="None" />
          </v-radio-group>
          <div
            v-if="actions.rf_settings_tile_interaction === 'none'"
            class="promo-design-group interactions-opt-item"
          >
            <div style="padding-bottom: 15px">
              <v-checkbox
                v-model="actions.rf_settings_close_button_enabled"
                label="Allow close"
                trueValue="true"
                falseValue="false"
                class="promotion-closeBtn-checkbox"
              />
            </div>
            <div v-if="actions.rf_settings_close_button_enabled === 'true'">
              <div style="padding-bottom: 20px">
                <RfPromoInteractionInterval
                  interactionType="dismiss"
                  :action="actions.rf_settings_dismiss_interval"
                  @setIntervalAction="setIntervalAction"
                />
              </div>
              <RfRetentionActionsBehavior :model="model" :actions="actions" displayOff />
            </div>
            <span class="gray-text">Only dismiss and timeout actions are possible</span>
          </div>
          <div
            v-if="actions.rf_settings_tile_interaction === 'container'"
            class="promo-design-group interactions-opt-item"
          >
            <RfTileContainerOptions :model="model" :actions="actions" />
          </div>
          <RfPromoInteractionInterval
            v-if="!isSticky && actions.rf_settings_tile_interaction !== 'none'"
            interactionType="clickButton1"
            :action="actions.rf_settings_accept_interval"
            @setIntervalAction="setIntervalAction"
          />
          <div>
            <v-checkbox
              v-model="thankYouEnabled"
              label="Show confirmation message"
              class="background-img-checkbox"
            />
            <v-text-field
              v-if="thankYouEnabled"
              v-model.trim="actions.rf_retention_acceptance_text"
              :class="thankYouEnabled ? '' : 'disabled-button'"
              density="compact"
              variant="outlined"
              persistentPlaceholder
              required
              label="Confirmation message"
              placeholder="e.g.: Thank you!"
              bgColor="#ffffff"
              hideDetails
              style="margin: 0 0 5px 28px"
            />
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel v-if="model.device_type === 'web'">
        <v-expansion-panel-title>Countdown Timer</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionActionsCountdown :model="model" :actions="actions" :app="app" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel v-if="inApp">
        <v-expansion-panel-title>In-App Purchase</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionActionsInapp :actions="actions" :app="app" :deviceType="model.device_type" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel v-if="model.device_type !== 'web'">
        <v-expansion-panel-title>Deep Link</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionActionsDeeplink :deviceType="model.device_type" :actions="actions" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>Device Metadata</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionActionsMetadata :actions="actions" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>CSS</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <div class="promo-design-group">
            <RfPromoCustomCSS :actions="actions" />
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel v-if="model.device_type === 'web' && app.flags.paywalls">
        <v-expansion-panel-title>Paywall</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfPaywallConfig :actions="actions" :model="model" />
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
  <div v-else>
    <v-expansion-panels v-model="getPromoPanel" multiple focusable>
      <v-expansion-panel>
        <v-expansion-panel-title>CONFIGURATION</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionActionsMobileWeb :app="app" :model="model" :actions="actions" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>CSS</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfPromoCustomCSS :actions="actions" />
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import RfRetentionActionsTitleMessage from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsTitleMessage.vue";
import RfRetentionActionsBehavior from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsBehavior.vue";
import UploadImageMixin from "@/utils/UploadImageMixin";
import RfRetentionActionsMobileWeb from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsMobileWeb.vue";
import RfPromoCustomCSS from "@/components/RfPromotions/RfPromoCustomCSS.vue";
import RfPromoInteractionInterval from "@/components/RfPromotions/RfPromoInteractionInterval.vue";
import RfTileContainerOptions from "@/components/RfPathCreate/RfRetentionActions/RfTileContainerOptions.vue";
import RfRetentionActionsCountdown from "./RfRetentionActionsCountdown.vue";
import RfRetentionActionsInapp from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsInapp.vue";
import RfRetentionActionsDeeplink from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsDeeplink.vue";
import RfRetentionActionsMetadata from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsMetadata.vue";
import RfPaywallConfig from "./RfPaywallConfig.vue";
import { hasInapp } from "@/utils/prompts/promptHelpers";
import { extendHex } from "@/utils/colorHelpers";

export default {
  name: "RfRetentionActionsTextPromo",
  components: {
    RfRetentionActionsTitleMessage,
    RfRetentionActionsBehavior,
    RfRetentionActionsMobileWeb,
    RfPromoCustomCSS,
    RfPromoInteractionInterval,
    RfTileContainerOptions,
    RfRetentionActionsCountdown,
    RfRetentionActionsInapp,
    RfRetentionActionsDeeplink,
    RfRetentionActionsMetadata,
    RfPaywallConfig,
  },
  mixins: [UploadImageMixin],
  props: ["actions", "model", "app", "viewTypeTab"],
  setup: () => ({ extendHex }),
  data() {
    return {
      getPromoPanel: [0],
      thankYouEnabled: this.model.id ? !!this.actions.rf_retention_acceptance_text : true,
    };
  },
  computed: {
    isSticky() {
      return (
        `${this.actions.rf_settings_permanent_display}` === "true" &&
        this.actions.rf_settings_tile_interaction === "container"
      );
    },
    inApp() {
      return hasInapp(this.model);
    },
  },
  watch: {
    thankYouEnabled(to) {
      if (!to) {
        this.actions.rf_retention_acceptance_text = null;
      }
    },
  },
  methods: {
    setIntervalAction(value, type) {
      this.actions[`rf_settings_${type}_interval`] = value;
    },
  },
};
</script>
